import React from 'react'

function UserLoader() {
  return (
    <>
    <div className="loaderHeight">
        <div className="loading_box">
            <div className="loader_circle"></div>
            <div className="loader_title_box"></div>
        </div>
        <div className="loading_box">
            <div className="loader_circle"></div>
            <div className="loader_title_box"></div>
        </div>
        <div className="loading_box">
            <div className="loader_circle"></div>
            <div className="loader_title_box"></div>
        </div>
        <div className="loading_box">
            <div className="loader_circle"></div>
            <div className="loader_title_box"></div>
        </div>
        <div className="loading_box">
            <div className="loader_circle"></div>
            <div className="loader_title_box"></div>
        </div>
        <div className="loading_box">
            <div className="loader_circle"></div>
            <div className="loader_title_box"></div>
        </div>
    </div>
    </>
  )
}

export default UserLoader